/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

//this could use some comments. what exactly is it going on
export const positionSlashMenu = (
  elementRef?: React.RefObject<HTMLDivElement>
): { top: number; left: number; shouldReverse: boolean } | null => {
  const selection = window.getSelection();
  if (!selection) return null;
  if (selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);

    const selectionRect = range.endContainer.hasChildNodes()
      ? range.endContainer.parentElement?.getBoundingClientRect()
      : range.getBoundingClientRect();
    const selectionTop = selectionRect!.y;
    const selectionLeft = selectionRect!.x;
    const element = elementRef?.current;
    const parentRect = getPositionedParent(element!)?.getBoundingClientRect();
    return {
      top: selectionTop - parentRect!.y + 20,
      left: selectionLeft - parentRect!.x - 2,
      shouldReverse: window.innerWidth - selectionLeft < 250, // 250 is the width of the menu (todo: make more robust)
    };
  }
  return null;
};

const getPositionedParent = (element: HTMLElement): HTMLElement | null => {
  if (!element) {
    return null;
  }
  const positionProperty = window.getComputedStyle(element).getPropertyValue("position");
  if (positionProperty !== "static") {
    return element;
  }
  if (!element.parentElement) return null;
  return getPositionedParent(element.parentElement);
};
